export default __webpack_public_path__ + "static/postgresql-3dd598d9d2b798c1ad3e2518b42f2a21.png";